import React from 'react';
import { Column, IBox, Title, Row, Content, Select, Button, Icon } from '../inspinia';
import HorarioAberturaEmail from './graficos/horarioAberturaEmail';

export default class Graficos extends React.Component {

    constructor() {
        super();

        this.state = {
            form: this.formInitialState(),
            isLoggedIn: true,
            grafico: ""
        }

        this.handleChange = this.handleChange.bind(this);
        this.handlePesquisarGrafico = this.handlePesquisarGrafico.bind(this);
    }

    formInitialState() {
        return {
            selecione: "Selecione..",
            tipoGrafico: "",
            tiposGraficos: this.loadTiposGraficos()
        }
    }

    loadTiposGraficos() {
        return {
            results: [
                {
                    label: "Horários de abertura",
                    value: 1
                }
            ]
        };
    }

    handleChange(e) {
        const form = this.state.form;
        this.state.isLoggedIn = false;
        this.setState({
            form: { ...form, tipoGrafico: e.target.value }
        });
    }

    handlePesquisarGrafico(e) {
        this.state.isLoggedIn = true;
        this.handleGrafico();
    }

    handleGrafico() {
        let tipoGrafico = this.state.form.tipoGrafico

        if (tipoGrafico == 1) {
            this.setState({
                grafico: <HorarioAberturaEmail />
            });
        }
    }

    render() {
        return (
            <div>
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title><h3 className="text-slate-grey">Gráficos - Buscar relatório</h3></Title>

                            <Content>
                                <Row className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Filtros:</label>
                                        <Select name="graficos" selected={this.state.form.selecione} data={this.state.form.tiposGraficos} onChange={this.handleChange} placeholder="Gráfico" />
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginTop: '28px', marginLeft: "5px" }}>
                                        <Button onClick={this.handlePesquisarGrafico}><Icon name="far fa-search" /> Pesquisar</Button>
                                    </div>
                                </Row>

                                {/* Gráfico */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0">
                                        {this.state.grafico}
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }
}